<template>
  <!-- Round-3 shared (#164): compact product detail popup.
       Pass a :product object; fields tolerate multiple key spellings. -->
  <el-dialog
    :title="$t('mt_shared.product_detail')"
    :visible.sync="innerVisible"
    width="440px"
    append-to-body
  >
    <div v-if="product" class="mt-prod-detail">
      <dl class="row mb-0">
        <dt class="col-4 text-muted">{{ $t('mt_shared.product_name') }}</dt>
        <dd class="col-8"><strong>{{ productName || "-" }}</strong></dd>

        <dt class="col-4 text-muted">{{ $t('mt_shared.wms_name') }}</dt>
        <dd class="col-8">{{ wmsName || notLinkedLabel }}</dd>

        <dt class="col-4 text-muted">{{ $t('mt_shared.sku_code') }}</dt>
        <dd class="col-8">{{ skuCode || notLinkedLabel }}</dd>

        <dt class="col-4 text-muted">{{ $t('mt_shared.barcode') }}</dt>
        <dd class="col-8">{{ barcode || notLinkedLabel }}</dd>
      </dl>
    </div>
    <div v-else class="text-muted text-center py-3">{{ $t('mt_shared.no_data') }}</div>

    <span slot="footer">
      <el-button @click="innerVisible = false">{{ $t('mt_shared.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog, Button } from "element-ui";

export default {
  name: "ProductDetailPopup",
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  props: {
    visible: { type: Boolean, default: false },
    // Accepts { product_name|name, wms_name|wms_product_name, sku_code|wms_man_pn|man_pn,
    // barcode|wms_barcode, wms_linked|wms_product_id } — tolerant of multiple key spellings
    // since the MT SO/import endpoints send slightly different shapes (#200).
    product: { type: Object, default: null },
  },
  data() {
    return { innerVisible: this.visible };
  },
  computed: {
    productName() {
      const p = this.product || {};
      return p.product_name || p.name || "";
    },
    wmsName() {
      const p = this.product || {};
      return p.wms_name || p.wms_product_name || p.wms || "";
    },
    skuCode() {
      const p = this.product || {};
      return p.wms_man_pn || p.sku_code || p.man_pn || p.code || "";
    },
    barcode() {
      const p = this.product || {};
      return p.wms_barcode || p.barcode || "";
    },
    // Whether the MT product is resolved to a WMS product. Prefer an explicit
    // flag/id from the BE; otherwise infer it from having any WMS field at all.
    wmsLinked() {
      const p = this.product || {};
      if (p.wms_linked !== undefined && p.wms_linked !== null) return !!p.wms_linked;
      if (p.wms_product_id !== undefined && p.wms_product_id !== null) return !!(Number(p.wms_product_id) > 0);
      return !!(this.wmsName || this.skuCode || this.barcode);
    },
    // Shown for the WMS-sourced fields (name/SKU/barcode) when empty: a plain
    // "-" if the product IS linked but a given sub-field is just blank, or a
    // clearer "not linked" message when the product has no WMS mapping at all.
    notLinkedLabel() {
      return this.wmsLinked ? "-" : this.$t("mt_shared.wms_not_linked");
    },
  },
  watch: {
    visible(v) {
      this.innerVisible = v;
    },
    innerVisible(v) {
      this.$emit("update:visible", v);
    },
  },
};
</script>
